const sortByCreatedTimestamp = (data: any[]) =>
  data.sort((a, b) => a.created.timestamp.seconds - b.created.timestamp.seconds);

export default sortByCreatedTimestamp;
